export enum Tasks {
    TASK_OT_LIST_FILTER_BY_CLIENT = 'TASK_OTS_FILTRAR_0004',
    TASK_REPORT_LIST_FILTER_BY_CLIENT = 'TASK_REPORTES_FILTRAR_0003',
    TASK_REPORT_ASSIGN_TO_CLIENT = 'TASK_REPORTES_ASIGNAR_0001',
    TASK_OT_EDIT = 'TASK_OTS_EDITAR_0005',
    TASK_REPORT_EDIT = 'TASK_REPORTES_EDITAR_0004',
};


/* KEY -> TASK_MODULO_OPCION_ACCION  */
/* VALUE -> CODIGO CREADO POR EL APP EN LA BASE DE DATOS */
